import { useEffect } from 'react';
import { parse } from 'search-params';
import { useLocation } from 'react-router-dom';

const UTM_STORAGE_KEY = 'UTM_PARAMS';

const useUTMQueryStrings = () => {
  const { search } = useLocation();

  useEffect(() => {
    const paramsObj = parse(search);

    if (paramsObj) {
      const paramsKeys = Object.keys(paramsObj);

      if (paramsKeys.length) {
        const utmParams = paramsKeys
          .filter((paramKey) => paramKey.indexOf('utm_') === 0)
          .reduce((reduced, key) => {
            reduced[key] = paramsObj[key];

            return reduced;
          }, {});

        // Only update sessionStorage if we have NEW UTM params in the URL
        // This preserves existing UTM params when navigating without UTM in URL
        if (utmParams && Object.keys(utmParams).length) {
          try {
            sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(utmParams));
          } catch {
            // Ignore storage errors (e.g., private browsing mode)
          }
        }
      }
    }
  }, [search]);
};

export default useUTMQueryStrings;
